import { LoadingOutlined } from '@ant-design/icons';

export const Loading: React.FC = () => (
  <LoadingOutlined />
);

